var ERRORS = require('../constants/error-types')

function checkRequired(data) {
  if (!data.required) {
    return data.value ? data : ''
  } else {
    // handle empty array values
    if (Array.isArray(data.value)) {
      return data.value.length ? data : ERRORS.required
    }

    if (data.hasOwnProperty('value')) {
      if (typeof data.value === 'string' && data.value.trim().length > 0) {
        return data
      } else if (typeof data.value === 'number' && data.value !== '') {
        return Object.assign({}, data, {
          value: data.value.toString(),
        })
      } else {
        return ERRORS.required
      }
    } else {
      return ERRORS.required
    }
  }
}

module.exports = checkRequired
